import { FC, useState, useMemo, ReactNode, CSSProperties } from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { ProTypography, ProTooltip } from '../antd';
import classnams from 'classnames';
import { TABLE_COLUMN_EMPTY } from '../constants/constant';
import { TooltipPlacement } from 'antd/lib/tooltip';
import { AlignType } from '../constants/interface';

export interface CopyTextProps {
  /** 复制到剪切板的文字 */
  text?: string;
  /** 是否为块级元素 */
  isBlock?: boolean;
  /** 宽 */
  width?: number | string;
  /** 最大宽度 */
  maxWidth?: number | string;
  /** 复制按钮图标 */
  icon?: ReactNode;
  /** 点击操作按钮后的提示文字 */
  tooltips?: [ReactNode, ReactNode];
  /** 最多展示几行文字 */
  ellipsisLine?: 1 | 2 | 3;
  /** 展示文字 */
  showText?: ReactNode;
  /** 气泡框位置 */
  placement?: TooltipPlacement;
  /** 是否显示气泡 */
  showTooltips?: boolean,
  /** 对齐方式 */
  align?: AlignType,
  /** 气泡框提示内容 */
  tooltipText?: ReactNode;
  /** 复制成功后的回调 */
  onCopy?: () => void;
}
const paragraphStyle: CSSProperties = { lineHeight: 'normal', };
/** 复制文字 */
const CopyText: FC<CopyTextProps> = props => {
  const {
    text,
    showText,
    isBlock,
    width,
    maxWidth,
    icon,
    tooltips,
    ellipsisLine,
    placement,
    showTooltips,
    align,
    tooltipText,
    onCopy,
  } = props;
  const [isMove, setIsMove] = useState<boolean>(false);
  const classes = classnams(`yb-line-ellipsis-${ellipsisLine}`, {
    'padding-right-12': !isMove,
  });
  const alignClasses = useMemo(() => {
    return classnams({
      "flex-center-start": align === 'left',
      "flex-center-center": align === 'center',
      "flex-center-end": align === 'right',
    })
  }, [align]);
  const divStyle = useMemo(() => {
    return isBlock
      ? { width, maxWidth }
      : { width, maxWidth, display: 'inline-flex' };
  }, [isBlock]);
  if (!text) return <div className={alignClasses} style={divStyle}>{TABLE_COLUMN_EMPTY}</div>;
  const renderHtml = (
    <div
      className={alignClasses}
      style={divStyle}
      onMouseEnter={() => setIsMove(true)}
      onMouseLeave={() => setIsMove(false)}
    >
      <span className={classes}>{showText || text}</span>
      {isMove && (
        <ProTypography.Paragraph
          className="margin-bottom-0"
          style={{lineHeight: 'normal', visibility: isMove ? 'visible' : 'hidden'}}
          copyable={{
            text: text,
            icon,
            tooltips,
            onCopy,
          }}
        />
      )}
    </div>
  );
  return (
    <>
      {
        showTooltips ? (
          <ProTooltip placement={placement} title={tooltipText || text} mouseEnterDelay={1}>
            {renderHtml}
          </ProTooltip>
        ) : renderHtml
      }
    </>
    
  );
};

CopyText.defaultProps = {
  isBlock: false,
  width: '100%',
  icon: <CopyOutlined />,
  tooltips: ['复制', '复制成功'],
  ellipsisLine: 1,
  placement: 'topLeft',
  showTooltips: true,
  align: 'left',
};

export default CopyText;
